import { I18nextProvider as ReactI18nextProvider, initReactI18next } from "react-i18next";
import i18next, { i18n } from "i18next";
import { Language, TranslationScopes } from "@finbackoffice/enums";
export { I18nContext } from "react-i18next";

export type IResourceBundlesV2 = { [scope: string]: { [key: string]: string } };

const createI18n = (() => {
    let instance: i18n | null = null;

    return (locale: string, resourcesFromServer: IResourceBundlesV2) => {
        if (instance) {
            for (const scope in resourcesFromServer) {
                instance.addResourceBundle(
                    locale,
                    scope,
                    resourcesFromServer[scope as TranslationScopes],
                );
            }

            if (instance.language !== locale) {
                void instance.changeLanguage(locale);
            }

            return instance;
        }

        instance = i18next.use(initReactI18next).createInstance(
            {
                fallbackLng: Language.en,
                lng: locale,
                debug: false,
                defaultNS: TranslationScopes.Common,
                resources: {
                    [locale]: resourcesFromServer,
                },
                interpolation: {
                    escapeValue: false,
                },
            },
            // callback forces init
            (err) => {
                if (err) return console.log("something went wrong while initializing i18n", err);
            },
        );

        return instance;
    };
})();

type IWithTranslationsProps = {
    translations: IResourceBundlesV2;
    locale: Language;
    children: React.ReactNode;
};

export const I18nextProviderV2 = (props: IWithTranslationsProps) => {
    const i18n = createI18n(props.locale, props.translations);

    return (
        <ReactI18nextProvider i18n={i18n} defaultNS={TranslationScopes.Common}>
            {props.children}
        </ReactI18nextProvider>
    );
};
